<mwe-button-link
  mweClickPreventDefault
  customCss="img-icon d-inline-flex align-items-center height-36"
  (clicked)="openPdf()"
  prependIconClass="fas fa-cloud-arrow-down"
  [showSpinner]="isLoading()"
  [label]="label()"
/>
